<template>
  <div>
    <v-layout class="mt-5 mb-2">
      <v-flex xs4 sm3 lg2 class="mr-3 ">
        <v-select
          v-model="buscarSelect"
          :items="buscaOptions"
          label="Tipo de busca"
          outlined
          menu-props="offsetY"
          :disabled="isFormLoading || (acao == 'novo' || acao == 'editar')"
          :background-color="isFormLoading || (acao == 'novo' || acao == 'editar') ? '#f2f2f2' : null"
          @change="onChangeBuscaOptions"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm9 lg6>
        <v-autocomplete
          v-model="searchSelected"
          :items="buscaGruposPreparacao"
          :hide-no-data="!search && buscaGruposPreparacao.length == 0 && !buscarLoading"
          :no-data-text="buscarLoading ? 'Carregando dados, aguarde...' : `Nenhuma opção encontrada com '${search}'`"
          outlined
          label="Buscar por"
          placeholder="Digite um valor para buscar"
          prepend-inner-icon="search"
          :search-input.sync="search"
          :filter="filtrarBusca"
          @keydown="buscar()"
          :loading="buscarLoading"
          @change="encontrado"
          :disabled="isFormLoading || (acao == 'novo' || acao == 'editar')"
          :background-color="isFormLoading || (acao == 'novo' || acao == 'editar') ? '#f2f2f2' : null"
        ></v-autocomplete>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :acao="acao"
      :id="form.identificadorgrupopreparacao"
      :novo="novoGrupoPreparacao"
      :editar="editarGrupoPreparacao"
      :excluir="excluirGrupoPreparacao"
      :cancelar="cancelarGrupoPreparacao"
      :submit="onSubmit">
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaGrupoPreparacao">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text >
          <v-row no-gutters>
            <v-col lg="7">
              <v-text-field label="Código do Grupo de Preparação" v-model="form.identificadorgrupopreparacao" outlined disabled background-color="#f2f2f2"></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col lg="7" class="mb-sm-5">
              <Validate :v="$v.form.descricaogrupopreparacao">
                <v-text-field
                  slot-scope="{ props }"
                  v-bind="props"
                  label="Descrição do Grupo de Preparação*"
                  v-model="form.descricaogrupopreparacao"
                  :disabled="isFormDisabled"
                  :background-color="isFormDisabled ? '#f2f2f2' : null"
                  outlined>
                </v-text-field>
              </Validate>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const GrupoPreparacaoRepository = RepositoryFactory.get("grupoPreparacao");

const setFormInicial = () => ({
  identificadorgrupopreparacao: '',
  descricaogrupopreparacao: '',
});

export default {
  name: 'GrupoPreparacao',
  data() {
    return {
      acao: '',
      form: setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      buscarSelect: 'descricaogrupopreparacao',
      buscaOptions: [
        { value: 'identificadorgrupopreparacao', text: 'Código' },
        { value: 'descricaogrupopreparacao', text: 'Descrição' },
      ],
      searchSelected: '',
      search: '',
      formUltimo: {},
      buscaGruposPreparacao: [],
      buscarLoading: false,
      filtrarBusca: this.filtrarBuscaDescricao,
      loading: false,
    };
  },
  validations: {
    form: {
      descricaogrupopreparacao: { required, maxLength: maxLength(50) },
    },
  },

  mounted() {
    this.$Progress.finish();
  },

  computed: {
    isFormDisabled() {
      return this.acao == '' || this.acao == 'excluir' || this.isFormLoading
    },
    isFormLoading() {
      return this.loading
    },
  },

  methods: {
    tabelaGrupoPreparacao() {
      this.$root.$router.push({
        name: 'tabelas',
        params: {
          titulo: 'Grupo de Preparação / Listar',
          rota_api: 'merenda/grupos-preparacao/tabela',
          headers: [{ text: 'Identificador', value: 'identificadorgrupopreparacao', sortable: false },
						          { text: 'Descrição', value: 'descricaogrupopreparacao', sortable: false }],
        },
      });
    },
    novoGrupoPreparacao() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.$v.$reset();
    },
    editarGrupoPreparacao() {
      this.acao = 'editar';
    },
    cancelarGrupoPreparacao() {
      if (this.acao == 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
      this.loading = false;
    },
    async excluirGrupoPreparacao() {
      this.acao = 'excluir';

      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este grupo de preparação?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          this.loading = true;
          const { data } = await GrupoPreparacaoRepository.deletarGrupoPreparacao(this.form.identificadorgrupopreparacao);

          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
          this.buscaGruposPreparacao = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }

      this.acao = '';
      this.loading = false;
    },

    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) return;
      this.loading = true;
      this.msgArrayError = []

      try {
        const { data } = await GrupoPreparacaoRepository[this.acao === 'novo' ? 'criarGrupoPreparacao' : 'editarGrupoPreparacao'](this.form);

        this.acao = '';
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...data.results };
        this.formUltimo = { ...this.form };
        this.$v.$reset();
        this.buscaGruposPreparacao = [];
      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.loading = false;
      }
    },

    filtrarBuscaCodigo(item, queryText, itemText) {
      return item.value == queryText
    },

    filtrarBuscaDescricao(item, queryText, itemText) {
      return itemText.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    },

    encontrado(dados) {
      this.form = setFormInicial();
      let dado = this.buscaGruposPreparacao.find(e => e.value == dados);
      this.form = { identificadorgrupopreparacao: dado.value, descricaogrupopreparacao: dado.text };
      this.formUltimo = { ...this.form };
      this.$nextTick(() => {
        this.searchSelected = null;
        this.search = '';
      });
      this.acao = '';
    },

    onChangeBuscaOptions(option) {
      if (option == 'identificadorgrupopreparacao') this.filtrarBusca = this.filtrarBuscaCodigo
      else if (option == 'descricaogrupopreparacao') this.filtrarBusca = this.filtrarBuscaDescricao
    },

    async buscar() {
      if (this.buscaGruposPreparacao.length || this.buscarLoading) return
      this.buscarLoading = true

      const { data } = await GrupoPreparacaoRepository.buscarGrupoPreparacao();
      for (const key of data.results) {
        this.buscaGruposPreparacao.push({ value: key.identificadorgrupopreparacao, text: key.descricaogrupopreparacao })
      }

      this.buscarLoading = false
    }
  },
};
</script>

<style>

</style>
